"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FamilyMemberResponseRelationshipEnum = void 0;
exports.FamilyMemberResponseRelationshipEnum = {
    Mother: 'Mother',
    Father: 'Father',
    Brother: 'Brother',
    Sister: 'Sister',
    PartnerMale: 'Partner (Male)',
    PartnerFemale: 'Partner (Female)',
    Son: 'Son',
    Daughter: 'Daughter',
    GrandmotherMaternal: 'Grandmother (maternal)',
    GrandfatherMaternal: 'Grandfather (maternal)',
    GrandmotherPaternal: 'Grandmother (paternal)',
    GrandfatherPaternal: 'Grandfather (paternal)',
    UncleMaternal: 'Uncle (maternal)',
    AuntMaternal: 'Aunt (maternal)',
    UnclePaternal: 'Uncle (paternal)',
    AuntPaternal: 'Aunt (paternal)',
    CousinMaleMaternal: 'Cousin (Male; maternal)',
    CousinFemaleMaternal: 'Cousin (Female; maternal)',
    CousinMalePaternal: 'Cousin (Male; paternal)',
    CousinFemalePaternal: 'Cousin (Female; paternal)',
    Nephew: 'Nephew',
    Niece: 'Niece',
    HalfBrotherMaternal: 'Half-brother (maternal)',
    HalfSisterMaternal: 'Half-sister (maternal)',
    HalfBrotherPaternal: 'Half-brother (paternal)',
    HalfSisterPaternal: 'Half-sister (paternal)',
    Grandson: 'Grandson',
    Granddaughter: 'Granddaughter',
    GrandmotherMaternalPaternalUnknown: 'Grandmother (maternal/paternal unknown)',
    GrandfatherMaternalPaternalUnknown: 'Grandfather (maternal/paternal unknown)',
    AuntMaternalPaternalUnknown: 'Aunt (maternal/paternal unknown)',
    UncleMaternalPaternalUnknown: 'Uncle (maternal/paternal unknown)',
    CousinMaleMaternalPaternalUnknown: 'Cousin (Male; maternal/paternal unknown)',
    CousinFemaleMaternalPaternalUnknown: 'Cousin (Female; maternal/paternal unknown)',
    CousinSexUnknownMaternal: 'Cousin (Sex unknown; maternal)',
    CousinSexUnknownPaternal: 'Cousin (Sex unknown; paternal)',
    CousinSexUnknownMaternalPaternalUnknown: 'Cousin (Sex unknown; maternal/paternal unknown)',
    NephewMaternalPaternalUnknown: 'Nephew (maternal/paternal unknown)',
    NieceMaternalPaternalUnknown: 'Niece (maternal/paternal unknown)',
    HalfBrotherMaternalPaternalUnknown: 'Half-brother (maternal/paternal unknown)',
    HalfSisterMaternalPaternalUnknown: 'Half-sister (maternal/paternal unknown)'
};
